/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, Typography, FormControl, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import './styles.scss';

const useStyles = makeStyles(theme => ({
  inputPlaceholder: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    color: 'red',
  },
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: 'blue',
    },
  },
  formControl: {
    minWidth: '100%',
  },
}));

const AutoSearch = (props) => {
  const [titleHide, setTitleHide] = useState(true);
  const classes = useStyles();
  const {
    id, name, value, isBillingAddress, required, label, placeholder, options, variant = 'outlined', error = null, defaultValue, onChange,labelClassName, ...others
  } = props;

  const [open, setOpen] = useState(false);
  const showDropdown = options.length > 1;

  useEffect(() => {
    const popupIndicator = document.getElementsByClassName('MuiAutocomplete-popupIndicator');
    if (popupIndicator && popupIndicator[0]) {
      popupIndicator[0]?.removeAttribute('title');
    }
  }, [titleHide]);

  const handleTitle = () => {
    setTitleHide(!titleHide);
    if (isBillingAddress && showDropdown) {
      setOpen(!open);
    }
  };

  return (
    <FormControl variant={variant} className={classes?.formControl}>
      {label &&
        <Typography
          component="p"
          className={
            `${required ? 'AutocompleteLabel required' : 'AutocompleteLabel'} ${labelClassName || ''}`
          }
        >{label}
        </Typography>
      }
      <Autocomplete
        id={id}
        name={name}
        value={value}
        options={options}
        open={isBillingAddress && open}
        onOpen={handleTitle}
        onClose={handleTitle}
        onChange={(e, itemValue) => onChange(itemValue)}
        getOptionLabel={option => option?.title || ''}
        defaultValue={defaultValue && defaultValue}
        disableClearable
        renderInput={params => (<TextField
          {...params}
          placeholder={placeholder || ''}
          variant={variant}
          className="style-input"
        />)}
        {...others}
      />
      {error && <FormHelperText className="MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense">{error}</FormHelperText>}
    </FormControl>
  );
};

export default AutoSearch;
